import { MessageIntent, Triggered_Message_Status } from '@occc/graphql';

export const TRIGGERED_MESSAGES_BASE_URL = '/triggered-messages';
export const MESSAGING_CENTER_BASE_URL = '/messaging-center';

export const PAGE_TITLE = 'Triggered Messages';
export const MESSAGING_CENTER_BREADCRUMB_LABEL = 'Messaging Center';

export const titleByStatus: Record<Triggered_Message_Status, string> = {
  [Triggered_Message_Status.Enabled]: 'Enabled',
  [Triggered_Message_Status.Disabled]: 'Disabled',
};

export const colorByStatus: Record<Triggered_Message_Status, 'success.main' | 'error.main'> = {
  [Triggered_Message_Status.Enabled]: 'success.main',
  [Triggered_Message_Status.Disabled]: 'error.main',
};

export const allStatuses: Triggered_Message_Status[] = [
  Triggered_Message_Status.Enabled,
  Triggered_Message_Status.Disabled,
];

export const STATUS_UPDATE_ERROR_MESSAGE =
  'There was an error updating the message status. Please try again.';
export const MESSAGE_UPDATE_SUCCESS = 'Message updated successfully.';

export { MessageIntent };

export const MESSAGE_INTENTS = [MessageIntent.Transactional, MessageIntent.Promotional] as const;
